module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_17_1.083dae95.jpeg";